import {
  Component,
  NgModule,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommentView } from '../../data/data.generated';
import { ButtonV2Module, IconModule } from '@gea/digital-ui-lib';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'hrt-comment',
  templateUrl: './hrt-comment.component.html',
  styleUrls: ['./hrt-comment.component.scss'],
  standalone: false,
})
export class HrtCommentComponent {
  @Input() comments: CommentView[] = [];
  @Input() commentType: string;
  @Input() canAddComment: boolean = true;
  @Output() commentAdded = new EventEmitter<string>();

  public newComment: string;

  ngOnInit() {}

  getUserInitials(username: string) {
    const firstName = username.split(' ')[0];
    const lastName = username.split(' ')[1];

    return firstName.charAt(0) + lastName.charAt(0);
  }

  sanitizeComment(text: string) {
    if (!text) return '';
    // Regular expression to detect URLs
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
    return text.replace(urlRegex, (url) => {
      // Add protocol if missing
      let href = url;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        href = 'https://' + url;
      }
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }

  addComment() {
    if (this.newComment == '' || !this.canAddComment) return;
    this.commentAdded.emit(this.newComment);
    this.newComment = '';
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const utcDateString = dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
    const date = new Date(utcDateString);
    return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
}

@NgModule({
  imports: [
    RouterModule,
    MaterialModule,
    BrowserModule,
    MatTooltipModule,
    ButtonV2Module,
    IconModule,
    FormsModule,
  ],
  exports: [HrtCommentComponent],
  declarations: [HrtCommentComponent],
})
export class HrtCommentsModule {}
